// components/Composite/Logos/Logos.js
import React from 'react';
import PropTypes from 'prop-types';
import { Logo } from '../../Atoms';

const toImageObj = (item) => (item && (item.image || item)) || null;

const LogoItem = ({ item }) => {
  const image = toImageObj(item);
  if (!image) return null;

  const Wrapper = item?.href ? 'a' : 'div';
  const wrapperProps = item?.href
    ? { href: item.href, target: '_blank', rel: 'noopener noreferrer' }
    : {};

  return (
    <Wrapper {...wrapperProps}>
      <Logo 
        image={image} 
        alt={item?.title || 'Partner logo'}
        size="lg"
        grayscale={false}
      />
    </Wrapper>
  );
};

const Logos = ({ value }) => {
  if (!value) return null;

  const { items = [], heading } = value;
  const arr = Array.isArray(items) ? items : [];
  
  if (arr.length === 0) {
    console.warn('[Logos] Empty items array');
    return null;
  }

  return (
    <section className="section section-full">      {/* MATCHES CardGrid default */}
      <div className="section__inner">
        
        {heading && (
          <div className="section__header">
            <div className="text-section-title">{heading}</div>
          </div>
        )}
        
        <div className="section__body">
          <div className="grid-5 grid-gap-normal">
            {arr.map((item, index) => (
              <LogoItem key={index} item={item} />
            ))}
          </div>
        </div>
        
      </div>
    </section>
  );
};

Logos.propTypes = {
  value: PropTypes.shape({
    items: PropTypes.array,
    heading: PropTypes.string,
  }),
};

export default Logos;